module.exports = __webpack_public_path__ + "img/ops_logo_en_white.77346cd0.png";